"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCompanyName;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var HUBS_ENDPOINT = 'hubs/v1/hubs';

var portalId = _hubspot.default.get();

var cachedCompanyName = null;

function fetchCompanyName() {
  if (cachedCompanyName) {
    return Promise.resolve(cachedCompanyName);
  }

  return _apiClient.default.get(HUBS_ENDPOINT + "/" + portalId).then(function (response) {
    var domain = response.domain,
        accountName = response.accountName,
        companyFooter = response.companyFooter;
    var companyName = domain;

    if (accountName) {
      companyName = accountName;
    } else if (companyFooter && companyFooter.indexOf('<') !== -1) {
      companyName = companyFooter;
    }

    cachedCompanyName = companyName;
    return companyName;
  });
}

module.exports = exports.default;